<template>
  <div class="order-wrapper primary-disabled">
    <portal target-el="#filter">
      <Breadcrumb
        :isHistoryBack="isHistoryBack"
        :hideBackBtn="hideBackBtn"
        :message="trackDetail.shipmentNumber">
      </Breadcrumb>
    </portal>
    <div v-if="!details.error">
      <div class="loading-app" v-if="isLoading">
        <Spinner />
      </div>

      <Row :gutter="20" class="row-reverse" v-else>
         <Col :xl="6" :lg="6" :md="8">
            <div class="slider-collapse wbview">
              <div class="drawer-header slider-collapse-header"  @click="active = !active">
                <span class="status status-icon status-grey">
                  {{status.name}}
                  <span class="badge" v-if="trackingType && trackingType.iconName">
                    <svgicon :name="trackingType.iconName" width="8" height="8" />
                  </span>
                </span>

                <span class="icon-mv">
                  <svgicon name="icon-add-dark"  v-if="active" width="16" height="16" :original="true"/>
                  <svgicon name="icon-minus-dark" v-else width="16" height="16" :original="true"/>
                </span>
              </div>
              <div class="drawer-body slider-collapse-body" :class="{ showview: active }">
                <ul class="drawer-list">
                  <li v-for="header in trackDetailsConstant" :key="header.id">
                    <label>{{header.title}}</label>
                    <div class="list-content">
                      {{trackDetail[header.column]}}
                      <small
                        v-if="header.subDetail && trackDetail[header.subDetail.column]"
                        :class="header.subDetail.class"
                      >
                      {{trackDetail[header.subDetail.column]}}
                      </small>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </Col>
          <Col :xl="18" :lg="18" :md="16" >
  <ElTabs class="tab-default">
    <Tab-pane label="Track">
      <div class="tab-content content-scroll-sm">
        <div style="text-align: right; margin-bottom: 10px;">
          <button type="button" @click="handleButtonClick($event)" :disabled="isLoading || mapLoading" class="check-location-btn">{{$t('REFRESH_LATEST_LOCATION')}}
          </button>
        </div>
        <div class="map-tracking">
          <div>
            <Spinner v-if="isLoading || mapLoading"/>
            <span class="status-msg" v-else-if="!this.details || !this.details.pings || !this.details.pings.length">
              <svgicon name="empty-location" width="100%" height="300" :original="true" />
              <p>{{$t('NO_LOCATION_FOUND')}}</p>
            </span>
            <div class="status-msg" v-else-if="!isLoading && !mapLoading">
              <iframe :src="trackUrl" frameborder="0" style="border:0"
                      width="100%" height="450"/>
            </div>
          </div>
        </div>
        <Table :data="stopsData" :stripe="true" class="table-striped bordered mt-20">
          <table-column
            v-for="column in pickDropOffConstants"
            :label="column.title"
            :width="column.width"
            :key="column.id"
          >
            <template slot-scope="scope">
              <span v-if="scope.row[column.label]">{{scope.row[column.label]}}</span>
              <span v-else>-</span>
            </template>
          </table-column>
        </Table>
      </div>
    </Tab-pane>
    <Tab-pane label="Timeline">
      <div class="tab-content content-scroll-sm">
        <div class="status-msg" v-if="!timelineEvent || !timelineEvent.length">
          <span>
            <svgicon name="empty-timeline" width="249" height="176" :original="true" />
            <p>No data found</p>
          </span>
        </div>
        <Row v-else>
          <Col :span="13">
            <Timelineblock 
            :timelineEvents="timelineEvent">
          </Timelineblock>
          </Col>
          <Col :span="11">
            <Table 
            :data="timelineData"
            :stripe="true"
            :max-height="windowHeight"
            class="table-striped bordered">
              <table-column
                v-for="column in timelineConstants"
                :prop="column.label"
                :label="column.title"
                :width="column.width"
                :key="column.id"
              ></table-column>
            </Table>
          </Col>
        </Row>
      </div>
    </Tab-pane>
  </ElTabs>
</Col>
      </Row>
 
    </div>
    <div v-else class="status-msg">
      <span>
        <svgicon name="empty-timeline" width="249" height="176" :original="true" />
        <p>No data found</p>
      </span>
    </div>
  </div>
</template>

<script>
import {
  mapGetters,
} from 'vuex';
import {
  pickDropOffConstants,
  timelineConstants,
  trackDetailsConstant,
  trackStatus,
  trackType,
  endTripMessage,
} from '@/constants/trackConstants';
import { getAddress, getLocation, getDistanceRem } from '@common/lib/track';
import {
  formatLastKnownTime,
  getDateDiffInDaysMins,
  formatDetailedTime,
  formatDetailedCommentDate,
  formatTime,
} from '@/lib/Date';
import moment from 'moment';
import Breadcrumb from '@/components/common/Breadcrumb';
import Timelineblock from '@common/components/Timelineblock';

export default {
  props: ['isOpenLink'],
  components: {
    Breadcrumb,
    Timelineblock,
  },
  data() {
    return {
      trackStatus,
      trackType,
      pickDropOffConstants,
      timelineConstants,
      trackDetailsConstant,
      details: {},
      isHistoryBack: true,
      hideBackBtn: false,
      active: false,
      mapLoading: false,
    };    
  },
  async mounted() {
    this.$store.commit('track/initialReset');
    const id = this.$route.query.id;
    this.details = await this.$store.dispatch('track/getTripDetails', { id, isOpenLink: this.isOpenLink });
    if (this.details && this.details.error) {
      this.$errorMessage({ message: this.details.error });
    }
    if (this.isOpenLink) {
      this.hideBackBtn = true;
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'track/isLoading',
      configurations: 'app/configurations',
      environmentVariables: 'app/environmentVariables',
    }),
    trackUrl() {
      const tripDetails = {
        locations: this.getLocations(this.details.pings || []),
        destination: this.getLocations(this.details.dropLatLongs || [], this.details.dropLocations, 'destination'),
        source: this.getLocations(this.details.pickupLatLongs || [], this.details.pickupLocations, 'source'),
        haltThreshold: (this.configurations && this.configurations.track_settings
          && this.configurations.track_settings.halt_threshold) || 2,
        // Defaut halt_threshold settings for open link
        // TODO: need to be fixed properly
        mapSettings: this.environmentVariables && this.environmentVariables.map_settings,
      };
      
      this.$session.set('mapData', tripDetails);
      return `${window.location.origin}/track/map`;
    },
    windowHeight() {
      return `${window.innerHeight - 210}px`;
    },
    status() {
      return this.trackStatus.find(val => val.value === this.details.status);
    },
    trackingType() {
      return this.trackType.find(val => val.value === this.details.typeOfTracking);
    },
    timelineData() {
      const timelineData = [];
      if (this.details && this.details.pings) {
        this.details.pings.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        this.details.pings.forEach((val) => {
          const obj = {
            date: formatDetailedCommentDate(val.created_at),
            location: val.address || val.city,
          };
          timelineData.push(obj);
        });
      }
      return timelineData;
    },
    stopsData() {
      const stopsArray = [];
      if (this.details && this.details.pickupLocations && ((!this.isOpenLink && !(this.configurations.track_settings
        && this.configurations.track_settings.hide_pickup_from_track)) || this.isOpenLink)) {
        this.details.pickupLocations.forEach((val) => {
          const obj = {
            stopType: 'Pickup',
            location: getLocation(val.address),
            estimatedArrival: formatDetailedTime(val.estimatedArrival),
            plannedArrival: formatDetailedTime(val.plannedArrival),
            distanceRemained: getDistanceRem(val.distanceRemained),
          };
          stopsArray.push(obj);
        });
      }
      if (this.details && this.details.dropLocations) {
        this.details.dropLocations.forEach((val) => {
          const obj = {
            stopType: 'Drop Off',
            location: getLocation(val.address),
            estimatedArrival: formatDetailedTime(val.estimatedArrival),
            plannedArrival: formatDetailedTime(val.plannedArrival),
            distanceRemained: getDistanceRem(val.distanceRemained),
          };
          stopsArray.push(obj);
        });
      }
      return stopsArray;
    },
    trackDetail() {
      const obj = {
        shipmentNumber: this.details.shipmentNumber,
        transporterName: this.details.transporterName,
        eta: formatDetailedTime(this.details.plannedEta),
        createdAt: formatDetailedTime(this.details.createdAt),
        driverNumber: this.details.driverPhoneNumber,
        driverName: this.details.driverName,
        status: this.status,
        truckNumber: this.details.truck_number,
        isGpsEnabled: (this.details.typeOfTracking === 'GPS') ? 'GPS ENABLED' : '',
      };
      if (this.details.firstPickup && this.details.firstPickup.address) {
        obj.source = this.details.firstPickup.address.name;
        obj.sourceAddress = getAddress(this.details.firstPickup.address);
      }
      if (this.details.lastDrop && this.details.lastDrop.address) {
        obj.destination = this.details.lastDrop.address.name;
        obj.destinationAddress = getAddress(this.details.lastDrop.address);
        const actualEtaAvl = (this.details.actualEta && this.details.actualEta !== 'NA');
        obj.actualEta = actualEtaAvl ? formatDetailedTime(this.details.actualEta) : '-';
        const etaDiff = actualEtaAvl && getDateDiffInDaysMins(this.details.actualEta, moment());
        obj.etaDetail = this.status &&
          !this.status.excludeEta ? etaDiff && etaDiff.formatted : null;
      }
      if (this.details.latestLocation) {
        obj.lastKnownPlace = this.details.latestLocation &&
          (this.details.latestLocation.city || this.details.latestLocation.address);
        obj.lastKnownTime = formatLastKnownTime(
          this.details.latestLocation.timeStamp,
        );
      }
      return obj;
    },
    timelineEvent() {
      let timelineData = [];

      timelineData = timelineData.concat(this.getTimelineData(this.details.pickupLocations, 'pickup'));
      timelineData = timelineData.concat(this.getTimelineData(this.details.dropLocations, 'drop'));

      if (this.details.endTripDetails) {
        for (let i = 0; i < this.details.endTripDetails.length; i += 1) {
          const endTripDetail = this.details.endTripDetails[i];
          const endTripReason = endTripMessage.find(reason =>
            reason.id === endTripDetail.reason);
          if (endTripReason && endTripReason.show) {
            let orderNo = 'NA';
            if (this.details.customerReferenceMap[endTripDetail.customerReference]) {
              orderNo = endTripDetail.customerReference;
            }
            const message = endTripReason.message
              .replace('#customerReference#', orderNo);
            let newMessage = message;
            if (this.details.entityType !== null && this.details.entityType !== 'NA') {
              newMessage += ' by ' + this.details.entityType;
            }
            const tripEndEvent = {
              timestamp: new Date(endTripDetail.timestamp),
              message: 'Trip completed',
              description: newMessage,
            };
            timelineData.push(tripEndEvent);
          }
        }
      }
      if (this.details.midwayChangeData) {
        const midwayChangeData = this.details.midwayChangeData;
        midwayChangeData.sort((a, b) => a.timestamp - b.timestamp);
        midwayChangeData.forEach((data) => {
          if (data.delta) {
            if (this.details.typeOfTracking === 'SIM') {
              const changedData = data.delta.driverPhoneNumber;
              if (changedData) {
                const obj = {
                  timestamp: new Date(data.timestamp),
                  message: 'Driver Phone Number Changed',
                  description: `Driver phone number changed from ${changedData[0]} to ${changedData[1]}`,
                };
                timelineData.push(obj);
              }
            } else {
              const changedData = data.delta.vehicleNumber;
              if (changedData) {
                const obj = {
                  timestamp: new Date(data.timestamp),
                  message: 'Vehicle Number Changed',
                  description: `Vehicle number changed from ${changedData[0]} to ${changedData[1]}`,
                };
                timelineData.push(obj);
              }
            }
          }
        });
      }
      if (this.details.tripHalts) {
        const tripHaltData = this.details.tripHalts;
        tripHaltData.sort((a, b) => a.endedAt - b.endedAt);
        tripHaltData.forEach((data) => {
          const duration = moment.duration(moment(data.endedAt).diff(moment(data.startedAt)));
          const totalMinutes = Number(duration.asMinutes().toFixed(2));
          const hours = Math.floor(totalMinutes / 60);
          const minutes = Math.floor(totalMinutes % 60);
          let timeDescription = hours && `${hours} hours`;
          const minutesDescription = minutes && `${minutes} minutes`;
          if (timeDescription) {
            timeDescription =
              minutesDescription ? `${timeDescription} and ${minutesDescription}` : timeDescription;
          } else {
            timeDescription = minutesDescription;
          }

          const obj = {
            timestamp: new Date(data.endedAt),
            message: 'Vehicle Halt',
            description: `Vehicle Halted at ${formatTime(data.startedAt)} for ${timeDescription}`,
          };
          timelineData.push(obj);
        });
      }
      // Trip created status
      timelineData.push({ message: 'Trip Created', timestamp: new Date(this.details.createdAt) });
      timelineData.sort((a, b) => a.timestamp - b.timestamp);
      return timelineData;
    },
  },
  methods: {
    async handleButtonClick(event) {
      this.mapLoading = true;
      const id = this.$route.query.id;
      const response = await this.$store.dispatch('track/getShipmentTrackLocations', { id, isOpenLink: this.isOpenLink });
      this.$set(this.details, 'pings', response.pings);
      this.mapLoading = false;
    },
    getTimelineData(locations, type) {
      const timelineData = [];
      if (locations) {
        locations.forEach((location) => {
          if (location.timelineData) {
            const entryData = location.timelineData.find(value => value.movementType === 'entry');
            const exitData = location.timelineData.find(value => value.movementType === 'exit');
            if (entryData) {
              const obj = {
                orderOfLocation: location.orderOfLocation,
                timestamp: new Date(entryData.time),
                message: (type === 'pickup') ? 'At Pickup' : 'Reached Destination',
                description: `Vehicle at ${location.address.name}`,
                ...(type === 'drop') ? { type: 'destination' } : {},
              };
              timelineData.push(obj);
            }
            if (exitData) {
              const obj = {
                orderOfLocation: location.orderOfLocation,
                timestamp: new Date(exitData.time),
                message: (type === 'pickup') ? 'Departed from pickup' : 'Released from destination',
                description: `Vehicle left ${location.address.name}`,
              };
              timelineData.push(obj);
            }
          }
        });
      }
      return timelineData;
    },
    getLocations(arr, details = [], markerValue = null) {
      const locations = [];
      arr && arr.forEach((val, index) => {
        let obj = {};
        if (markerValue) {
          // assuming the index of latlong array and location details array match
          const title = (details && details[0]) &&
            details[index].address.name;
          obj[markerValue] = title;
        }
        obj = Object.assign(obj, {
          lat: val.lat,
          lon: val.lon,
          createdAt: val.created_at,
        });
        locations.push(obj);
      });
      return locations;
    },
  },
};
</script>

<style scoped>
.check-location-btn {
  padding: 10px 20px;
  background-color: #007fea;
  font-size: 1.4rem;
  color: white;
  border: none;
  cursor: pointer;
}
</style>